import { createDefaultMutationHook } from "hooks/useMutationHandler";

import { DELETE_PROVIDER } from "./gql";

const useDeleteProvider = createDefaultMutationHook(DELETE_PROVIDER);

export default useDeleteProvider;
